import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { notificationAPI } from '../../api'

export const notificationKeys = {
  all: ['notifications'] as const,
  lists: () => [...notificationKeys.all, 'list'] as const,
  list: (filters: { unreadOnly?: boolean; page?: number }) =>
    [...notificationKeys.lists(), filters] as const,
  unreadCount: () => [...notificationKeys.all, 'unread-count'] as const,
}

export function useNotifications({ unreadOnly = false, page = 1 } = {}) {
  return useQuery({
    queryKey: notificationKeys.list({ unreadOnly, page }),
    queryFn: () => notificationAPI.getNotifications(page, 20, unreadOnly),
  })
}

export function useNotificationUnreadCount({ enabled = true } = {}) {
  return useQuery({
    queryKey: notificationKeys.unreadCount(),
    queryFn: () => notificationAPI.getUnreadCount(),
    refetchInterval: enabled ? 60000 : false,
    enabled,
  })
}

export function useMarkNotificationRead() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => notificationAPI.markRead(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: notificationKeys.all })
    },
  })
}

export function useMarkAllNotificationsRead() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: () => notificationAPI.markAllRead(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: notificationKeys.all })
    },
  })
}
